import { Box, Heading, Stack, Text } from '@chakra-ui/react'

type HowItWorksItem = {
  title: string
  description: string
}

const HOW_IT_WORKS: HowItWorksItem[] = [
  {
    title: 'Choose a Khan Academy Test',
    description:
      'Test your knowledge across the entire course, or just in a single topic—both qualify you to tutor. ' +
      'Nervous? You can review and practice the unit before on Khan Academy.',
  },
  {
    title: 'Record a video',
    description:
      `To verify your knowledge as you take the test, you'll explain your reasoning out loud ` +
      'while recording a video that shares your screen and your webcam.',
  },
  {
    title: 'Submit with at least a score of 90%',
    description:
      `To submit your certification, you'll need to get at least 90% of questions correct. ` +
      `Didn't quite make it? You can keep practicing and record your video as many times as you need.`,
  },
  {
    title: 'Get your certification',
    description:
      `Once your video has been reviewed by peer volunteers, you're certified! ` +
      `You'll get an official tutor badge in this World and get an email with a publicly shareable ` +
      'link to your Schoolhouse.world certification transcript.',
  },
]

export default function HowItWorks(): JSX.Element {
  return (
    <Stack direction="column" spacing="24px">
      <Stack spacing="8px">
        <Heading size="xl">How it Works</Heading>
        <Text>
          These steps only apply to video certifications, not honorary certifications such as for
          APs or the SAT.
        </Text>
      </Stack>

      <Stack direction="column" spacing="32px">
        {HOW_IT_WORKS.map(({ title, description }, index) => (
          <Stack key={title} direction="row" align="center" spacing="24px">
            <Box width="30px" textAlign="center">
              <Heading size="2xl" color="fg.subtle">
                {index + 1}
              </Heading>
            </Box>
            <Stack direction="column" spacing="4px" flex={1}>
              <Text fontWeight="bold">{title}</Text>
              <Text color="fg.muted" variant="supporting">
                {description}
              </Text>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}
